module.exports = "<app-project-list></app-project-list>"